import { render, staticRenderFns } from "./commonConfig_group.vue?vue&type=template&id=0b54451c"
import script from "./commonConfig_group.vue?vue&type=script&lang=js"
export * from "./commonConfig_group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports